import React, { useEffect, useState } from "react";
import ReCAPTCHA from 'react-google-recaptcha'
import { Link } from 'react-router-dom';
import { useFormik } from 'formik';
import validate from '../assests/js/validate';
import { useNavigate } from "react-router-dom";
import { FaEyeSlash } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { ToastContainer, toast } from 'react-toastify';
import GisApiServices from "../services/GisApiServices";
import { jwtDecode } from 'jwt-decode';
import { setAuthData } from "../store/slice/authdataslice";
import { useDispatch } from "react-redux";

const Login = () => {
    const [CurrentPass, setCurentPass] = useState(true);
    const navigate = useNavigate();
    const emailE = process.env.REACT_APP_EMAIL_ID;
    const passP = process.env.REACT_APP_PASS_WORD;
    const authVaribale = process.env.REACT_APP_AUTH;
    const [decoded, setDecoded] = useState(null);
    const [error, setError] = useState('');
    const dispatch = useDispatch();

    // --- CHANGE 1: State to manage the ReCAPTCHA token and key ---
    const [captchaToken, setCaptchaToken] = useState(null);
    const [siteKey, setSiteKey] = useState(null);

    // Load site key from .env file when the component mounts
    useEffect(() => {
        const key = process.env.REACT_APP_SITE_KET_CAPTCHA;
        if (key) {
            setSiteKey(key);
        } else {
            console.error("ReCAPTCHA Error: Site key not found in .env file.");
            toast.error("ReCAPTCHA is not configured correctly.");
        }
    }, []);

    // --- CHANGE 2: Function to handle successful captcha verification ---
    const handleCaptchaChange = (token) => {
        console.log("ReCAPTCHA token received:", token);
        setCaptchaToken(token);
    };

    const initialValues = authVaribale === "true"
        ? {
            password: '',
            userid: '',
        }
        : {
            password: '',
            email: '',
        };

    const onSubmit = async (values, { setSubmitting }) => {
        // --- CHANGE 3: Check if ReCAPTCHA was completed before submitting ---
        if (!captchaToken) {
            toast.error("Please complete the ReCAPTCHA challenge.");
            setSubmitting(false); // Prevent form submission
            return;
        }

        if (authVaribale === "true") {
            try {
                const response = await GisApiServices.loginGis(values);
                const encryptedToken = response.data.data;
                handleDecode(encryptedToken);
                localStorage.setItem("token", encryptedToken);
                navigate("/misdashboard");
                toast.success(response.data.message, { autoClose: 3000 });
            } catch (error) {
                const errorMessage = error.response?.data?.message || "Login failed";
                toast.error(errorMessage, { autoClose: 2000 });
            } finally {
                setSubmitting(false);
            }
        } else {
            if (values.email === emailE && values.password === passP) {
                localStorage.setItem("token", "auth");
                navigate("/dashboard");
            } else {
                toast.error("Invalid credentials.");
            }
            setSubmitting(false);
        }
    };

    const formik = useFormik({
        initialValues,
        // validate,
        onSubmit
    });

    const handleDecode = (encryptedToken) => {
        try {
            const payload = jwtDecode(encryptedToken);
            setDecoded({ payload });
            dispatch(setAuthData(payload));
            console.log('Decoded Payload:', payload);
            setError('');
        } catch (err) {
            setError('Invalid JWT token');
            setDecoded(null);
        }
    };

    const handlePassword = () => {
        setCurentPass(!CurrentPass);
    }

    return (
        <>

            <div div className="container-fluid p-0">

                <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

                <div className='topheadercontainer login-topheader'>
                    <div className='toheader topheaderleftdiv'>
                        <img src="img/email.png" alt='email' className='top-content-lg' />
                        <h6 className='topheader-title m-0 top-content-lg'>citizenhelpdesk@mpurban.gov.in</h6>
                        <h6 className='topheader-title m-0 top-content'>Government OF MADHYA PRADESH</h6>
                    </div>
                    <div className='toheader topheaderleftdiv'>
                        <img src="img/social-icons.png" alt='facebook' />
                        <img src="img/social-icons-one.png" alt='facebook' />
                        <img src="img/social-icons-two.png" alt='facebook' />
                        <img src="img/email.png" alt='email' />
                    </div>
                </div>
                <div className="row gx-0">
                    <div className="col-xl-7 col-lg-7 col-md-7 co-12">
                        <div className="login-left-content ">
                            {/* <img src={LoginBanner} className="login-img"/> */}
                            <div className="ui-content">
                                <div className="row">
                                    <div className="col-md-12">
                                        <h6 className="login-lefttitle m-0">Welcome to Urban</h6>
                                        <h6 className="login-lefttitle m-0">Data Analytics</h6>
                                        <h3 className="login-insights m-0">Urban Insights at Your Fingertips</h3>
                                        <p className="loginpara m-0">Transforming Data into Decisions. Discover your city like <br /> never before.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-5 col-lg-5 col-md-5 co-12">
                        <div className="login-right">
                            <Link to="/" style={{ textDecoration: 'none' }}>
                                <div className="row align-items-center">
                                    <div className="col-xxl-6 col-xl-8 col-lg-9 col-md-12 col-12">
                                        <div className="loginlogodiv">
                                            <img src="img/mplogo.png" alt="Logo" width="53px" height="53px" />
                                            <div>
                                                <p className="m-0 govt-title">Directorate, Urban Administration & Development Government of Madhya Pradesh</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                            <h1 className="logintitle">Login to your account</h1>
                            {/* <p className="login-pera">Vorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum.</p> */}
                            {/* <div className="d-flex justify-content-center">
                            <img src={mapLogin} alt="login" width="200px" height="140px"/>
                         </div> */}

                            <form onSubmit={formik.handleSubmit} className="loginform">
                                {authVaribale == 'true' ?
                                    <div>
                                        <input
                                            id="userid"
                                            name="userid"
                                            type="userid"
                                            className='form-control'
                                            onChange={formik.handleChange}
                                            value={formik.values.userid}
                                            placeholder='User id'
                                        />
                                        {formik.errors.userid ? <div className="error-message">{formik.errors.userid}</div> : null}
                                    </div>
                                    :
                                    <div>
                                        <input
                                            id="email"
                                            name="email"
                                            type="email"
                                            className='form-control'
                                            onChange={formik.handleChange}
                                            value={formik.values.email}
                                            placeholder='Email'
                                        />
                                        {formik.errors.email ? <div className="error-message">{formik.errors.email}</div> : null}
                                    </div>
                                }


                                {/* 
                               
                            <div>
                                    <input
                                        id="userid"
                                        name="userid"
                                        type="userid"
                                        className='form-control'
                                        onChange={formik.handleChange}
                                        value={formik.values.userid}
                                        placeholder='User id'
                                    />
                                    {formik.errors.userid ? <div className="error-message">{formik.errors.userid}</div> : null}
                                </div>
                            */}


                                <div className="position-relative">
                                    <input
                                        id="password"
                                        name="password"
                                        type={CurrentPass ? "password" : 'text'}
                                        className='form-control'
                                        onChange={formik.handleChange}
                                        placeholder='Enter Password'
                                        value={formik.values.password}
                                    />
                                    <div className='eyediv' style={{ color: "#7E7E7E" }}>
                                        <div type="button" onClick={() => handlePassword()}>
                                            {CurrentPass ? <FaEye /> : <FaEyeSlash />}
                                        </div>
                                    </div>
                                    {formik.errors.password ? <div className="error-message">{formik.errors.password}</div> : null}
                                </div>
                                <div className="recaptcha-container mt-2" style={{ transform: "scale(0.85)", transformOrigin: "0 0" }}>
                                    {siteKey ? (
                                        <ReCAPTCHA
                                            sitekey={siteKey}
                                            onChange={handleCaptchaChange}
                                            onExpired={() => setCaptchaToken(null)} // Reset token on expiry
                                            onErrored={() => toast.error("ReCAPTCHA failed to load. Please try again.")}
                                        />
                                    ) : (
                                        <p className="error-message">ReCAPTCHA is not available.</p>
                                    )}
                                </div>
                                <button type="submit" className="btn-login">Login</button>
                            </form>


                            <p className="login-link mt-2 mb-0">Don’t have an account? <Link to="/singup">Create now</Link></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Login